import { BlockQuote, Box } from 'app/components/marketist';
import cn from 'clsx';
import css from './publication-quote.module.css';
type PublicationQuoteProps = {
  quote: React.ReactNode;
  logo: React.ReactElement;
  shape?: 'rectangle' | 'square';
};
export function PublicationQuote({
  quote,
  logo,
  shape = 'rectangle'
}: PublicationQuoteProps) {
  return <Box className={css.publicationQuote} data-sentry-element="Box" data-sentry-component="PublicationQuote" data-sentry-source-file="publication-quote.tsx">
            <BlockQuote className={css.blockquote} size="quote-base" data-sentry-element="BlockQuote" data-sentry-source-file="publication-quote.tsx">
                {quote}
            </BlockQuote>
            <Box className={cn(css.logoContainer, css[shape])} data-sentry-element="Box" data-sentry-source-file="publication-quote.tsx">{logo}</Box>
        </Box>;
}